/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookmarkIcon32Regular = forwardRef('BookmarkIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10 7a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H10Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 2A5.5 5.5 0 0 0 5 7.5v19.077c0 2.295 2.473 3.74 4.473 2.613l6.036-3.402a1 1 0 0 1 .982 0l6.036 3.402c2 1.127 4.473-.318 4.473-2.613V7.5A5.5 5.5 0 0 0 21.5 2h-11ZM7 7.5A3.5 3.5 0 0 1 10.5 4h11A3.5 3.5 0 0 1 25 7.5v19.077a1 1 0 0 1-1.491.87l-6.036-3.402a3 3 0 0 0-2.946 0L8.49 27.448A1 1 0 0 1 7 26.577V7.5Z" })));
});
